<div class="headers">
  <div class="info">
    <div style="margin-bottom: 10px;">{{chartName}}</div>
    <div>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut.</div>
  </div>
  <div class="filters">
    <select>
      <option selected disabled>Select</option>
      <option value="hourly">Hourly</option>
      <option value="daily">Daily</option>
      <option value="weekly">Weekly</option>
      <option value="monthly">Monthly</option>
      <option value="quarterly">Quarterly</option>
    </select>
    <div class="download">
      <img src="assets/images/download.svg" />
    </div>
    <div class="zoom">
      <img src="assets/images/fullscreen.svg" />
    </div>
  </div>
</div>
<div class="chart-container">
  <canvas [id]="chartId" width="1800" height="458"></canvas>
</div>